import React from "react"


import "../style/footer.css"
import Contact from "./contact"


export default function Footer (props)
{


    return(
        <div className="footer_container">
            <Contact/>
            <div className="contac_me">created by hezi rahmani 2020</div>
            
        </div>
    )
}